import axios from "axios";
import moment from "moment";

const CRUD_KEY = "WTw0fEUjXau3J5e79L6iycALE2456sRef9i0vw5kU";
const CRUD_NAME = "console";

const axiosWithConsoleCreds = (nonDefaultBaseURL) => {
    return axios.create({
        headers: {
            authorization: CRUD_NAME,
            "wsc-api-key": CRUD_KEY,
        },
        baseURL: nonDefaultBaseURL || "https://api.v3.invintusmedia.com",
    });
};

export const getTechniciansNonPaged = async (clientID) => {
    const response = await axiosWithConsoleCreds().post(
        `/V2/Console/getTechniciansNonPage`,
        {
            clientID,
        }
    );

    return response.data.data.clientTechs;
};

export const getCalendarEvents = async ({
    clientID,
    startDateTime,
    stopDateTime,
    techID,
}) => {
    const response = await axiosWithConsoleCreds().post(
        `/V2/Console/getEventsSlim`,
        {
            clientID,
            startDateTime,
            stopDateTime,
            techID,
            resultMax: 1000,
            includePrivate: true,
            showTechnician: true,
        }
    );

    return response.data.data.map((event) => {
        let end;

        if (event.autoStopTime) {
            end = moment(event.autoStopTime).toDate();
        } else if (event.estRuntime) {
            end = moment(event.startDateTime)
                .add(event.estRuntime, "minutes")
                .toDate();
        } else if (event.stopDateTime) {
            end = moment(event.stopDateTime).toDate();
        } else {
            end = moment(event.startDateTime).toDate();
        }

        return {
            data: { ...event },
            id: event.eventID,
            status: event.eventStatus,
            title: event.title,
            start: moment(event.startDateTime).toDate(),
            end,
            technicians: event.technicians
                ? event.technicians.map((tech) => tech.techName)
                : [],
        };
    });
};

export const getEvent = async ({ clientID, eventID }) => {
    const response = await axiosWithConsoleCreds().post(
        `/V2/Console/getEvent`,
        {
            clientID,
            eventID,
            includePrivate: true,
        }
    );

    return response.data.data;
};

export const addEventTechnician = async ({
    clientID,
    eventID,
    technicianIDs,
}) => {
    const response = await axiosWithConsoleCreds(
        "https://crud.v3.invintusmedia.com"
    ).post(`/events/update`, {
        clientID,
        eventID,
        technicians: technicianIDs,
    });

    return response.data.data;
};

export const deleteTechnician = async ({ clientID, techID }) => {
    const response = await axiosWithConsoleCreds(
        "https://crud.v3.invintusmedia.com"
    ).post(`/techs/delete`, {
        clientID,
        techID,
    });

    return response.data.data;
};

export const updateTechnician = async ({ clientID, techID, techName }) => {
    const response = await axiosWithConsoleCreds(
        "https://crud.v3.invintusmedia.com"
    ).post(`/techs/update`, {
        clientID,
        techID,
        techName,
    });

    return response.data.data;
};

export const getUsers = async ({ clientID }) => {
    const response = await axiosWithConsoleCreds(
        "https://crud.v3.invintusmedia.com"
    ).post(`/Users/getUsers`, {
        clientID,
    });

    return response.data.data;
};

export const createTechnician = async ({ clientID, techName, userId }) => {
    const response = await axiosWithConsoleCreds(
        "https://crud.v3.invintusmedia.com"
    ).post(`/techs/add`, {
        clientID,
        techName,
        userId,
    });

    return response.data.data;
};
